import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "./authentication.service";

export const authGuardIsSignedIn:
    CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const authService = inject(AuthenticationService);
        const router = inject(Router);

        if (authService.isLoggedIn()) {
            return true
        }

        const signInPath = router.parseUrl(`/sign-in?returnUrl=${state.url}`);
        console.warn(`Not logged in, redirecting to `, signInPath);
        return new RedirectCommand(signInPath, { skipLocationChange: true });
    };